import { mediaRequest, uploadMediaTo } from "./projectMediaClient.js";

const path = id => `/api/locations/${encodeURIComponent(id)}/media`;
export async function getLocationMedia(id) {
  const result = await mediaRequest(path(id));
  if (!Array.isArray(result?.items) || typeof result?.capabilities?.canManage !== "boolean" ||
      !Object.hasOwn(result, "effectiveCover")) throw new Error("The server returned an invalid office media list.");
  return result;
}
export const uploadLocationMedia = (id, file, _week, onProgress, signal) => uploadMediaTo(path(id), file, null, onProgress, signal);
export const updateLocationMedia = (id, mediaId, caption) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}`, {
  method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ caption }),
});
export const removeLocationMedia = (id, mediaId) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}`, {
  method: "DELETE", headers: { "Content-Type": "application/json" }, body: JSON.stringify({}),
});
export const restoreLocationMedia = (id, mediaId, undoToken) => mediaRequest(`${path(id)}/${encodeURIComponent(mediaId)}/restore`, {
  method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ undoToken }),
});
export const reorderLocationMedia = (id, ids) => mediaRequest(`${path(id)}/order`, {
  method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ ids }),
});
export const setLocationCover = (id, mediaId) => mediaRequest(`${path(id)}/cover`, {
  method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ mediaId: mediaId ?? null }),
});
const EVENT = "places:location-media-changed";
export function emitLocationMediaChanged(id, source = null, result = undefined) {
  if (typeof window !== "undefined") window.dispatchEvent(new CustomEvent(EVENT, { detail: { locationId: String(id), source, ...(result ? { result } : {}) } }));
}
export function onLocationMediaChanged(id, handler) {
  if (typeof window === "undefined") return () => {};
  const fn = e => { if (e.detail?.locationId === String(id)) handler(e.detail); };
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}
export const officeMediaAdapter = Object.freeze({
  entityType: "office", list: getLocationMedia, upload: uploadLocationMedia,
  update: updateLocationMedia, remove: removeLocationMedia, setCover: setLocationCover, restore: restoreLocationMedia, reorder: reorderLocationMedia,
  emit: emitLocationMediaChanged, subscribe: onLocationMediaChanged,
});
